import React, { useState } from "react";
import { Modal, Button as Btn, Form, Input, Card, notification } from "antd";
import Button from "./button";
import Close from "../../assets/icons/close.svg";
import colors from "../../share/constants/constants";
import { approveBusiness } from "../../api/business";

const YupupQuantityModal = ({ onCancel, onOk, data, text, title, promo, getBusinessDetails }) => {
  const [form] = Form.useForm();
  const [inProgress, setInProgress] = useState(false);


  const onFinish = async (value) => {
    setInProgress(true);
    const payload = {
        maxQuantity: value.maxQuantity || data?.business?.maxQuantity,
    };
    const res = await approveBusiness(data?.business?._id, payload);
    if (res) {
      onCancel();
      setInProgress(false);
      notification.success({
        message: 'Update Successful',
        description: 'Max quantity updated successfully',
      });
      getBusinessDetails(data?.business?._id);
    }
  };

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        width="450px"
        onCancel={onCancel}
      >
        <Card className="border-2 px-2">
        <div className="flex">
            <h2 className="flex-1">Manage Max Quantity</h2>
            <img src={Close} alt="Cross Icon" className="w-3.2 cursor-pointer" onClick={() => onCancel()} />
          </div>
          <Form form={form} onFinish={onFinish}>
            <div className="">
              <div>
              <Form.Item name="maxQuantity">
                <div>
                  <div>
                    <h3>Max Quantity</h3>
                  </div>
                  <Input
                    type="number"
                    className="flex items-center w-full h-5.4"
                    placeholder={`Max Quantity`}
                    defaultValue={data?.business?.maxQuantity}
                  />
                </div>
              </Form.Item>
              </div>
            </div>
              <Form.Item className="flex justify-center">
                <Button
                  title={"Save"}
                  color={colors.primaryPurple}
                  htmlType="submit"
                  //   onClick={onOk}
                  className="flex items-center w-full"
                  loading={inProgress}
                />
              </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default YupupQuantityModal;
